enum ChatNotificationType {
  Error = 'Error',
  Warning = 'Warning',
}

export default ChatNotificationType;
